export default function httpRequest(url, callback) {
  var xhr = new XMLHttpRequest();
  function errorCallback(error) {
    xhr.abort();
    callback(error, xhr);
  }
  xhr.onreadystatechange = function () {
    try {
      if (!/\.svg/i.test(url) && xhr.readyState === 2) {
        var contentType = xhr.getResponseHeader('Content-Type');
        if (!contentType) {
          errorCallback(new Error('Content type not found'));
          return;
        }
        if (!(contentType === 'image/svg+xml' || contentType === 'text/plain')) {
          errorCallback(new Error("Invalid content type: ".concat(contentType)));
          return;
        }
      }
      if (xhr.readyState === 4) {
        if (xhr.status === 404 || xhr.responseXML === null) {
          errorCallback(new Error("Unable to load SVG file: ".concat(url)));
          return;
        }
        if (xhr.status === 200) {
          callback(null, xhr);
        } else {
          errorCallback(new Error("There was a problem injecting the SVG: ".concat(xhr.status, " ").concat(xhr.statusText)));
        }
      }
    } catch (error) {
      xhr.abort();
      callback(error, xhr);
    }
  };
  xhr.open('GET', url);
  // xhr.withCredentials = true;
  if (xhr.overrideMimeType) {
    xhr.overrideMimeType('text/xml');
  }
  xhr.send();
}